<template>
    <div class="dashboard">
        <div class="row" v-if="dataDash3.consulted">
            <!-- Columna Izquierda: Gráfico circular y Stats -->
            <div class="col-12 col-lg-4 position-relative">
                <h1 class="main-title mb-2">Tablero de Usabilidad</h1>
                <div class="dashboard-left-content d-flex flex-column align-items-center">
                    <!-- Gráfico circular -->
                    <div class="donut-block">
                        <DanutChart :percentage="getPercentageUsersActive" inactiveColor="#dee2e6" :size="300" />
                        <StatCard text="Porcentaje usuarios con actividad periodo" />
                        <StatCard
                            v-if="dataDash3.consulted"
                            :number="getTotalActiveUsers"
                            text="Usuarios activos"
                            class="mt-2"
                        />
                    </div>
                    <!-- TODAS las Stats debajo del donut -->
                    <div class="all-stats-container w-100 mt-4" v-if="dataDash3.consulted && dataDash3.cards">
                        <!-- Recorrido dinámico de todas las categorías -->
                        <div v-for="(cards, categoryName) in dataDash3.cards" :key="categoryName" class="stats-section mb-2">
                            <div class="chart-header">
                                <h5 class="chart-title">{{ categoryName }}</h5>
                            </div>
                            <div class="dynamic-stats-grid">
                                <StatCard 
                                    v-for="card in cards" 
                                    :key="card.label"
                                    :number="card.total" 
                                    :text="card.label" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Columna Derecha: Gráfica de barras y ranking -->
            <div class="col-12 col-lg-8 d-flex flex-column">
                <!-- Gráfica de barras -->
                <div class="row chart-section">
                    <div class="col-12">
                        <ChartCard title="Usabilidad" chartKey="usabilidad" :options="usabilityChartOptions"
                            :isLoading="false" messageNoData="No hay datos de usabilidad" />
                    </div>
                </div>
                <!-- Ranking de usuarios -->
                <div class="row ranking-section">
                    <div class="col-12">
                        <UserRanking title="Ranking de usuarios activos" :users="getRankingData" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { validarPermisoComponente } from "../../../plugins/acl";
import StatCard from "../components/StatCard.vue";
import DanutChart from "../components/usability/DanutChart.vue";
import ChartCard from '../components/health/ChartCard.vue';
import UserRanking from '../components/usability/UserRanking.vue';
import {
    getUsabilityChartOptions
} from '../config/chartOptions';

export default {
    name: 'Health',
    components: {
        StatCard,
        DanutChart,
        ChartCard,
        UserRanking
    },
    data() {
        return {
            validarPermisoComponente: validarPermisoComponente,
            // Observadores para altura dinámica
            resizeObserver: null,
            mutationObserver: null,
            scrollableHeight: 'auto',
            // Debounce para optimizar
            resizeTimeout: null,
            isLoadingChartInfo: {
                functionality: false,
            }
        };
    },
    mounted() { },
    computed: {
        ...mapState("dashboard", ["screens", "dataDash1", "dataDash2", "dataDash3", "dashboardFilters"]),
        // Estilos computados para el contenedor scrollable
        scrollableStyles() {
            return {
                maxHeight: this.scrollableHeight,
                height: this.scrollableHeight
            };
        },
        usabilityChartOptions() {
           if(this.dataDash3.consulted){
            return getUsabilityChartOptions(this.dataDash3.top_functionalities);
           }
           return {};
        },

        getPercentageUsersActive() {
            if(this.dataDash3.consulted){
                return this.dataDash3.users_actives.percentage;
            }
            return 0;
        },

        getRankingData() {
            if(this.dataDash3.consulted && this.dataDash3.top_users){
                return this.dataDash3.top_users;
            }
            return [];
        },

        getTotalActiveUsers() {
            if (this.dataDash3.consulted && this.dataDash3.users_actives) {
                return this.dataDash3.users_actives.count_users_active || 0;
            }
            return 0;
        }
    },
    methods: {
        ...mapActions("dashboard", ["findDataProducts", "findDataProductsByCompanyAndSegment"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),
        async handleChartInfo({ key, title }) {
            console.log(key, title);
        },
        async handleSegmentClick(data) {
            console.log(data);
        }
    }
};
</script>

<style scoped>
/* ESTILOS GENERALES */
.dashboard {
    min-height: 100vh;
    padding: 0 15px;
    overflow-x: hidden;
}

.main-title {
    font-size: 1.8rem;
    font-weight: 800;
    color: #1B212E;
    z-index: 10;
    position: relative;
    margin-bottom: 0;
}

.card {
    border-radius: 18px;
    border: none;
}

.chart-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
}

.chart-title {
    position: relative;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.donut-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-top: 0;
    position: relative;
    z-index: 1;
}

.d-flex {
    display: flex;
}

.gap-1 {
    gap: 4px;
}

.card-header {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

/* NUEVA SECCIÓN DE STATS DEBAJO DEL DONUT */
.all-stats-container {
    width: 100%;
    position: relative;
    z-index: 2;
}

.stats-section {
    background: transparent;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    position: relative;
    z-index: 2;
}
</style>

<!-- ESTILOS GLOBALES PARA FORZAR ALTURA UNIFORME -->
<style>
/* GRID DINÁMICO PARA STATS - ALTURA UNIFORME FORZADA */
.dynamic-stats-grid {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 4px !important;
    align-items: stretch !important;
    width: 100% !important;
    grid-auto-rows: 1fr !important;
    /* CLAVE: filas de igual altura */
}

/* Forzar altura en TODOS los elementos hijos */
.dynamic-stats-grid>*,
.dynamic-stats-grid .stat-card,
.dynamic-stats-grid>div,
.dynamic-stats-grid>*>div,
.dynamic-stats-grid>*>* {
    height: 100% !important;
    min-height: 80px !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    box-sizing: border-box !important;
    width: 100% !important;
}

/* Elemento único ocupa todo el ancho */
.dynamic-stats-grid> :only-child {
    grid-column: 1 / -1 !important;
}

/* Responsive heights - Tablet */
@media (max-width: 1199px) and (min-width: 768px) {

    .dynamic-stats-grid>*,
    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>div,
    .dynamic-stats-grid>*>* {
        min-height: 75px !important;
    }
}

/* Responsive heights - Mobile Large */
@media (max-width: 767px) and (min-width: 576px) {

    .dynamic-stats-grid>*,
    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>div,
    .dynamic-stats-grid>*>* {
        min-height: 70px !important;
    }
}

/* Responsive heights - Mobile */
@media (max-width: 575px) {
    .dynamic-stats-grid {
        grid-template-columns: 1fr 1fr !important;
        /* 2 columna en móviles */
    }

    .dynamic-stats-grid>*,
    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>div,
    .dynamic-stats-grid>*>* {
        min-height: 65px !important;
    }
}

/* Responsive heights - Mobile pequeño */
@media (max-width: 480px) {

    .dynamic-stats-grid>*,
    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>div,
    .dynamic-stats-grid>*>* {
        min-height: 60px !important;
    }
}
</style>

<style scoped>
/* ESTILOS GENERALES */
.dashboard {
    min-height: 100vh;
    padding: 0 15px;
    overflow-x: hidden;
}

.main-title {
    font-size: 1.8rem;
    font-weight: 800;
    color: #1B212E;
    z-index: 10;
    position: relative;
    margin-bottom: 0;
}

.card {
    border-radius: 18px;
    border: none;
}

.chart-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
}

.chart-title {
    position: relative;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.donut-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-top: 0;
    position: relative;
    z-index: 1;
}

.d-flex {
    display: flex;
}

.gap-1 {
    gap: 4px;
}

.card-header {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

/* NUEVA SECCIÓN DE STATS DEBAJO DEL DONUT */
.all-stats-container {
    width: 100%;
    position: relative;
    z-index: 2;
}

.stats-section {
    background: transparent;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    position: relative;
    z-index: 2;
}

/* GRID DINÁMICO PARA STATS - ENFOQUE ROBUSTO CON ALTURA UNIFORME */
.dynamic-stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    align-items: stretch;
    /* CLAVE: Esto hace que todos los elementos tengan la misma altura */
    width: 100%;
    grid-auto-rows: 1fr;
    /* NUEVO: Fuerza filas de igual altura */
}

.dynamic-stats-grid>* {
    /* Eliminar propiedades conflictivas y asegurar altura uniforme */
    flex: unset;
    min-width: unset;
    max-width: unset;
    width: 100%;
    height: 100% !important;
    /* FORZAR altura al 100% */
    min-height: 80px !important;
    /* FORZAR altura mínima */
    box-sizing: border-box;
    display: flex !important;
    align-items: center;
    justify-content: center;
}

/* Si solo hay 1 hijo, ocupa todo el ancho */
.dynamic-stats-grid> :only-child {
    grid-column: 1 / -1;
}

/* Fallback para flexbox si grid no es soportado */
@supports not (display: grid) {
    .dynamic-stats-grid {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        min-height: 80px;
    }

    .dynamic-stats-grid>* {
        flex: 1 1 calc(50% - 2px);
        min-width: calc(50% - 2px);
        max-width: calc(50% - 2px);
        min-height: 80px !important;
    }

    .dynamic-stats-grid> :only-child {
        flex: 1 1 100%;
        min-width: 100%;
        max-width: 100%;
    }
}

/* FORZAR estilos al componente StatCard - MUY ESPECÍFICO */
.dynamic-stats-grid>*,
.dynamic-stats-grid .stat-card,
.dynamic-stats-grid>div,
.dynamic-stats-grid>*>*,
.stats-section .dynamic-stats-grid>* {
    min-height: 80px !important;
    height: 100% !important;
    width: 100% !important;
    box-sizing: border-box !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
}

/* Estilos específicos para el componente StatCard */
.stat-card,
.dynamic-stats-grid .stat-card {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    height: 100% !important;
    min-height: 80px !important;
    padding: 12px !important;
    box-sizing: border-box !important;
}

/* SECCIONES PRINCIPALES */
.chart-section {
    position: relative;
    z-index: 1;
}

.ranking-section {
    position: relative;
    z-index: 2;
    clear: both;
}

.clearfix::after {
    content: "";
    display: table;
    clear: both;
}

/* RESPONSIVE BREAKPOINTS */
/* Desktop Large */
@media (min-width: 1200px) {
    .dashboard {
        padding: 0 20px;
    }
}

/* Desktop */
@media (min-width: 992px) {
    .dashboard-left-content {
        min-height: 500px;
    }
}

/* Tablet - iPad */
@media (max-width: 1199px) and (min-width: 768px) {
    .main-title {
        font-size: 1.8rem;
    }

    .chart-title {
        font-size: 16px;
    }

    .dynamic-stats-grid {
        min-height: 75px !important;
        grid-auto-rows: 1fr;
    }

    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>*,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>* {
        min-height: 75px !important;
        height: 100% !important;
    }
}

/* Tablet Small */
@media (max-width: 991px) and (min-width: 768px) {
    .main-title {
        font-size: 1.8rem;
    }

    .chart-title {
        font-size: 16px;
    }

    .dynamic-stats-grid {
        min-height: 75px !important;
        grid-auto-rows: 1fr;
    }

    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>*,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>* {
        min-height: 75px !important;
        height: 100% !important;
    }
}

/* Mobile Large */
@media (max-width: 767px) and (min-width: 576px) {
    .dashboard {
        padding: 0 5px;
    }

    .main-title {
        font-size: 1.6rem;
    }

    .chart-title {
        font-size: 15px;
        font-weight: 700;
    }

    .donut-block {
        margin-top: 0;
        margin-bottom: 16px;
    }

    .dynamic-stats-grid {
        min-height: 70px !important;
        grid-auto-rows: 1fr;
    }

    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>*,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>* {
        min-height: 70px !important;
        height: 100% !important;
    }

    .stat-card {
        padding: 10px !important;
    }
}

/* Mobile */
@media (max-width: 575px) {
    .dashboard {
        padding: 0 1px;
    }

    .dynamic-stats-grid {
        grid-template-columns: 1fr;
        /* Una sola columna en móviles pequeños */
        gap: 4px;
        min-height: 65px !important;
        grid-auto-rows: 1fr;
    }

    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>*,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>* {
        min-height: 65px !important;
        height: 100% !important;
    }

    .stat-card {
        padding: 8px !important;
    }

    .main-title {
        font-size: 1.4rem;
    }

    .chart-title {
        font-size: 14px;
        font-weight: 700;
    }

    .donut-block {
        margin-top: 0;
        margin-bottom: 12px;
    }
}

/* Mobile muy pequeño */
@media (max-width: 480px) {
    .main-title {
        font-size: 1.3rem;
    }

    .chart-title {
        font-size: 13px;
    }

    .dynamic-stats-grid {
        min-height: 60px !important;
        grid-auto-rows: 1fr;
    }

    .dynamic-stats-grid .stat-card,
    .dynamic-stats-grid>*,
    .dynamic-stats-grid>div,
    .dynamic-stats-grid>*>* {
        min-height: 60px !important;
        height: 100% !important;
    }
}

/* BREAKPOINTS ESPECÍFICOS PARA EVITAR MONTAJE EN DIFERENTES ZOOMS */
@media (max-width: 1400px) and (min-width: 1200px) {
    .main-title {
        font-size: 1.5rem;
    }
}

@media (max-width: 1200px) and (min-width: 992px) {
    .main-title {
        font-size: 1.2rem;
    }

    .chart-title {
        font-size: 16px;
    }
}

/* BREAKPOINTS ADICIONALES PARA ZOOMS ESPECÍFICOS */
@media (max-width: 1100px) and (min-width: 992px) {
    .dashboard-left-content {
        min-height: 450px;
    }
}

@media (max-width: 1050px) and (min-width: 992px) {
    .dashboard-left-content {
        min-height: 400px;
    }
}

/* Ajustes específicos para el responsive title */
.title-responsive {
    font-size: 1.8rem;
}

@media (max-width: 1850px) {
    .title-responsive {
        font-size: 1.8rem;
    }
}

@media (max-width: 1155px) {
    .title-responsive {
        font-size: 1.8rem;
    }
}

@media (max-width: 900px) {
    .title-responsive {
        font-size: 1.5rem;
    }
}

@media (max-width: 700px) {
    .title-responsive {
        font-size: 1.3rem;
    }
}

@media (max-width: 600px) {
    .title-responsive {
        font-size: 1.2rem;
    }
}

/* PREVENCIÓN FINAL DE MONTAJE */
.dashboard * {
    box-sizing: border-box;
}

.dashboard .position-relative {
    position: relative !important;
}

/* Espaciado consistente */
.mb-1 {
    margin-bottom: 0.25rem !important;
}

.mb-2 {
    margin-bottom: 0.5rem !important;
}

.mb-3 {
    margin-bottom: 1rem !important;
}

.mb-4 {
    margin-bottom: 1.5rem !important;
}

.mt-4 {
    margin-top: 1.5rem !important;
}

/* Overflow control */
.dashboard {
    overflow-x: hidden;
}

.all-stats-container,
.stats-section {
    overflow: hidden;
}
</style>